import { Component } from 'react'
import { Helmet } from 'react-helmet'
import styles from './Warehouse.css'

import { Switch, Redirect } from 'react-router-dom'
import Main from '../../containers/Main'
import RouteWithSubRoutes from '../../lib/RouteWithSubRoutes'

const HelmetSetting = () => (
  <Helmet>
    <title>快倉作業</title>
  </Helmet>
)

class Warehouse extends Component {
  componentDidMount () {
  }

  render () {
    const props = this.props
    const { routes } = props

    return (
      <Main
        routes={routes}
        render={(mainProps) => {
          return (
            <div
              className={styles.warehouse}
              data-role='warehouse'
            >
              <HelmetSetting />
              <div className='pure-g'>
                <div className={'pure-u-1'}>
                  <Switch>
                    {
                      routes.map((route, i) => {
                        return (
                          <RouteWithSubRoutes
                            key={i}
                            {...route}
                            {...mainProps}
                            {...props}
                          />
                        )
                      })
                    }
                    {/* 預設導向到效期警示頁面 */}
                    <Redirect to='/warehouse/expiringItems' />
                  </Switch>
                </div>
              </div>
            </div>
          )
        }}
      />
    )
  }
}

export default Warehouse
